var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.0001L-7.57104e-07 17.6604L4.5 9.00012L0 0.339843L15 9.0001Z",
    fill: "#9A9BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon2);
export default __webpack_public_path__ + "static/media/Polygon2.94ffb80b883308f2fc627c9e1a6fc8ea.svg";
export { ForwardRef as ReactComponent };